import React from 'react';
import { Sidebar, Element, Button, CrossSquareIcon } from '@quotient/riq-react-ui';
import { ShoppingList } from '@quotient/riq-shoppinglist';

const ShoppingListComp = ({ data }) => {
  const [isSidebarOpen, setSidebar] = React.useState(false);
  const toggleSidebar = () => setSidebar(!isSidebarOpen);

  return (
    <ShoppingList data={data}>
      <ShoppingList.CartCounter
        colors={{
          bgActive: 'secondary',
          bgInactive: 'secondary',
          textColorActive: 'white',
          textColorInActive: 'white'
        }}
        css={{ marginLeft: '10px' }}
        onClick={toggleSidebar}
      />
      <Sidebar width="400px" isOpen={isSidebarOpen} onDismiss={toggleSidebar} aria-labelledby="My Shopping List">
        <Sidebar.CloseDialog onDismiss={toggleSidebar} closeIcon={<CrossSquareIcon css={{ color: 'secondary' }} />} />
        <ShoppingList.Header />
        <ShoppingList.Body
          closeIcon={<CrossSquareIcon css={{ color: 'secondary' }} />}
          css={{ color: 'secondary' }}
          data={data.arrItems}
        >
          <ShoppingList.AddItemForm
            size="small"
            AddOnButton={
              <Button type="submit" variant="primary" size="large" css={{ width: '48px', fontSize: '32px' }}>
                +
              </Button>
            }
          />
          <Element as="hr" css={{ margin: 0, height: 2, background: 'grays.400', width: '100%' }} />
        </ShoppingList.Body>
        <ShoppingList.Footer
          colors={{
            bgActive: 'secondary',
            bgInactive: 'grays.500',
            textColorActive: 'white',
            textColorInActive: 'white'
          }}
          dialogButtonVariant="secondary"
          closeIcon={<CrossSquareIcon css={{ color: 'secondary' }} />}
        />
      </Sidebar>
    </ShoppingList>
  );
};

export { ShoppingListComp };
